import { connect } from 'react-redux'
import { resetCartForm, setCartDate } from 'actions/account/cart'

const mapStateToProps = ({ cart: { cartForm } }) => ({ cartForm })
const actions = { resetCartForm, setCartDate }

const withRedux = connect(mapStateToProps, actions)

export default withRedux
